module.exports = __webpack_public_path__ + "static/inrvaernarhro_mtg_afr-409a1defda4ba7f9e24e5a4f97635dcd.jpg";